module.exports = __webpack_public_path__ + "static/media/Logo_v2_transparent.4265bf2d.png";